import { Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-manual-cancel-time-dialog',
  templateUrl: 'manual-cancel-time-dialog.component.html',
  styleUrls: ['manual-cancel-time-dialog.component.scss'],
})
export class ManualCancelTimeDialogComponent {
  date: string = new Date().toISOString().split('T')[0];
  time: string = new Date().toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  });

  constructor(
    private ngZone: NgZone,
    private dialogRef: MatDialogRef<ManualCancelTimeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  close() {
    this.dialogRef.close();
  }

  submit() {
    const timestamp = new Date(`${this.date}T${this.time}`);
    this.dialogRef.close(timestamp);
  }
}
